// extracted by mini-css-extract-plugin
module.exports = {"list-item":"ThirdPartyListItem-module__list-item___3ko2a","listItem":"ThirdPartyListItem-module__list-item___3ko2a","buttons":"ThirdPartyListItem-module__buttons___qtnNJ"};